import React from "react";
import { Link } from "react-router-dom";

class Modal extends React.Component{
    render(){
        return(
            <div className={this.props.active ? "modal active" : "modal"}>  
                <Link to={'../theory'} className="btn__theory btn">Изучить теорию</Link> 
                <Link to={'../quiz'} className="btn__lesson btn">Начать урок</Link> 
            </div>
        )
    }
}


export default Modal